export const environment = {
    production: false,
    debug: true,
    name: "local",

    API_URL: "https://alpha-dev-platform-capp.calmforest-6dbf5289.germanywestcentral.azurecontainerapps.io/mvsa",
    MS_graph_endpoint : "https://graph.microsoft.com/v1.0/me",
    oauth2_issuer: "https://alpha-dev-auth-server-capp.calmforest-6dbf5289.germanywestcentral.azurecontainerapps.io", // "http://localhost:8081",

    // gateway is not used, the tenant information is passed directly
    gateway: "https://alpha-prod-gateway.calmforest-6dbf5289.germanywestcentral.azurecontainerapps.io", // http://localhost:8082,

    tenant_alias: null,
    tenant_name: null,
    tenant_logoColorBright: null,
    tenant_logoColorDark: null,
    tenant_logoBright: null,
    tenant_logoDark: null,

};

